import React, {Component} from 'react'

import KebabmenuItemComponent from './KebabmenuItem.component'

class KebabmenuItemContainer extends Component {
    handleClick = (evt) => {
      evt.preventDefault()

      this.props.analytics.propagateEvent({
        eventType: 'click',
        action: 'Kebab menu item',
        label: this.props.label,
        type: 'Data Table'
      })

      if (this.props.actionType === 'callback') {
        this.props.env.callFunction(this.props.action, [this.props.dataRow])
      }
    }

    render() {
      const events = {
        handleClick: this.handleClick
      }

      return (
        <KebabmenuItemComponent
          events={events}
          actionType={this.props.actionType}
          label={this.props.label}
          action={this.props.action}
        />
      )
    }
}

export default KebabmenuItemContainer
